import { Button } from '~/shared/ui/Button/Button';
// import Plus from '/public/icons/plus.svg?react';
import Profile from '/public/icons/user.svg?react';
import { cvaHeader } from '~/widgets/Header/HeaderStyles';
import { myPlacesState } from '~/shared/store/myPlacesStore';
import { cvaIcon } from '~/shared/styles/IconStyles';
import { FC, useEffect, useRef, useState } from 'react';
import { AddressSuggestions } from 'react-dadata';
import { useMainPageStore } from '~/pages/MainPage/model/useMainPageStore';

// import { API } from '~/shared/API/api';

interface Props {
  places: myPlacesState[];
  totalProfit: number;
}

export const Header: FC<Props> = () => {
  const suggestionsRef = useRef<AddressSuggestions>(null);
  const [address, setAddress] = useState<any>('');
  const { state, actions } = useMainPageStore();
  const { search } = state;
  const { setSearch, setIsOpen } = actions;

  useEffect(() => {
    if (address?.value) {
      const newPlace = {
        address: address?.value,
        lat: address?.data.geo_lat,
        lon: address?.data.geo_lon,
        zoom: address?.data.house ? 18 : address?.data.street ? 16 : 12,
      };
      // localStorage.setItem('search-parking', JSON.stringify(newPlace));
      setSearch(newPlace);
    }
  }, [address]);

  // useEffect(() => {
  //   const search = localStorage.getItem('search-parking');
  //   search && setSearch(JSON.parse(search));
  // }, []);

  return (
    <div className={cvaHeader({ position: 'left' })}>
      {/* {places && places.length > 0 ? (
        <span className={cvaHeaderProfit()}>{priceFormatter(totalProfit)}</span>
      ) : (
        <Button
          variant={'darkGray'}
          size={'common'}
          href={'/add-place'}
          rubber
          icon={<Plus className={cvaIcon({ iconSize: 'secondary' })} />}>
          Добавить своё место
        </Button>
      )} */}
      <AddressSuggestions
        // filterLocations={[{ region: 'Москва' }]}
        ref={suggestionsRef}
        hintText={'Выберите вариант или продолжите ввод'}
        inputProps={{ placeholder: 'Поиск парковки' }}
        minChars={3}
        count={3}
        token="9194d427ec19a2fd3ccee5e2b2cf4613c796ba08"
        value={address === '' && search ? search.address : address}
        onChange={setAddress}
        delay={500}
        containerClassName={'w-full'}
        hintClassName={'w-full text-[1.3rem] text-[#7C7B83]'}
        highlightClassName={'text-white !bg-[#252331]'}
        currentSuggestionClassName={'w-full'}
        suggestionClassName={'suggestion'}
        //  onFocus="this.value = this.value;"
        //  filterRestrictValue={true}
      />
      <Button
        className="h-5.9 min-w-5.9"
        //  href={'/profile'}
        onClick={() => setIsOpen('menu')}
        variant={'darkGray'}
        size={'common'}
        onlyIcon
        icon={
          <Profile className={cvaIcon({ iconSize: 'secondary' })} />
        }></Button>
    </div>
  );
};
